<template>
    <div class="logo-on">

<!--        <div class="new-year-dialog-box">-->
<!--            <van-overlay :show="dialogshow" @click="dialogshow = true">-->
<!--                <div class="wrapper" v-if="dialogshow">-->
<!--                    <img src="~@public/img/newIndex/123456789.jpg" class="dialog-img"/>-->
<!--                </div>-->
<!--            </van-overlay>-->
<!--        </div>-->

        <img class="logo" src="../../../public/img/signup/logo.png">
        <router-link tag="a" :to="'/new/login?returnUrl='+returnUrl" class="denglbtn">登录</router-link>
        <router-link tag="a" to="/sign-up/register" class="zhucbtn" @click="">注册</router-link>
      <!--<div style="display: flex;justify-content: space-between">
        <router-link tag="a" to="/legal-person-register/index" class="zhucbtn" >法人注册</router-link>
        <router-link tag="a" to="/sign-up/register" class="zhucbtn" @click="">自然人注册</router-link>
      </div>-->
    </div>
</template>

<script>
    import {Icon, Swipe, SwipeItem, Toast, Dialog, Overlay,Popup } from 'vant';
    export default {
        components: {
            [Popup.name]: Popup,
            [Icon.name]: Icon,
            [Swipe.name]: Swipe,
            [SwipeItem.name]: SwipeItem,
            [Overlay.name]: Overlay,
            [Dialog.Component.name]: Dialog.Component,
        },
        name: "index",
        data(){
            return{
                dialogshow:true,
                returnUrl:"",
            }
        },
        mounted(){
            if (this.$route.query.returnUrl) {
                this.returnUrl = this.$route.query.returnUrl;
            }
        },
        methods: {
            goServiceZc() {
                Dialog.alert({
                    message: '平台注册进行维护中，请前往鄂汇办或政务网进行注册后在进行登录办理！！！'
                }).then(() => {

                });
            },
        }
    }
</script>

<style scoped>

    @import "~@assets/css/public/signup.css";
    .new-year-dialog-box {
        z-index: 10000;
    }

    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        height: 100%;
        z-index: 10000;
    }

    .dialog-img {
        width: 100%;
    }

    .dialog-close {
        width: 42px;
    }
    .logo-on{padding: 180px 30px 0 30px}
    .logo-on a{width: 100%;border-radius:44px;height: 88px;line-height: 88px;text-align: center;font-size: 36px;display: block}
    .denglbtn{background: #0e67e7;color: #fff;border: 1px solid #0e67e7;margin-top: 220px}

    .zhucbtn {
      background: transparent;
      color: #0e67e7;
      border: 1px solid #0e67e7;
      margin-top: 60px;
      /*width: 48%!important;*/
    }
</style>
